import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3 className="footer-logo">AI CoE</h3>
                    <p>Revolutionizing the world through professional AI research and innovative gesture-controlled technology.</p>
                </div>

                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/research">Research</Link></li>
                        <li><Link to="/projects">Projects</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h4>Connect</h4>
                    <div className="social-links">
                            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                            <a href="https://github.com/yourusername/GestureWeb" target="_blank" rel="noopener noreferrer">GitHub</a>
                            <a href="https://twitter.com/yourusername" target="_blank" rel="noopener noreferrer">Twitter</a>
                    </div>
                </div>

                <div className="footer-section">
                    <h4>Admin</h4>
                    <Link to="/admin/login" className="admin-link">Portal Login</Link>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} AI Center of Excellence. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
